module.exports = __webpack_public_path__ + "media/images/shared/logo_sp-cd844e734b66f4209d4e0def16b10b20.svg";